import React, { Component } from 'react';
import './right.styles.scss';

class Rights extends Component {
    render() {
        return (
            <div className='rights'>
                <span>Patents Pending</span>
                <span> &copy; Renteasy</span>
                
            </div>
        )
    }
}

export default Rights;
